"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledPageWrapper = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.StyledPageWrapper = styled_components_1.default.div.withConfig({ displayName: "StyledPageWrapper", componentId: "sc-gmmmbf" }) `
  flex: 1;
`;
